module.exports = __webpack_public_path__ + "static/media/BACKGROUND2.05010c3f.svg";